// src/pages/HomePage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { loadStripe } from '@stripe/stripe-js';
import { auth } from '../firebaseConfig';
import InternalMessenger from '../components/InternalMessenger'; 
import ExamDrum from '../components/ExamDrum'; 
import BorealisBadge from '../components/BorealisBadge'; // ✅ IMPORT BADGE

const stripePromise = loadStripe('pk_live_51S9DkiKAY8PM72prQaMsHqI8XCqSHJ2q5u639tBw8C9HUsRUjClAdCakpx4T5zBvsW2lkHddGz9jPsmjLdt4n9Uy003KA5MnRR');

// ... (KEEP STRIPE_PRICES, AVATAR_MAP, and LANGUAGE_NAMES exactly as they are) ...
const STRIPE_PRICES = {
  cabin: { group: { annual: 'price_1SJhpBKAY8PM72pr20MtJF3G', monthly: 'price_1S9XRZKAY8PM72pr84LTbwL4', hour: 'price_1S9XRZKAY8PM72prmfbBlrg7' }, oneOnOne: { annual: 'price_1S9XN7KAY8PM72prBFRjGxyd', monthly: 'price_1S9XOtKAY8PM72prIJAdQDXX', hour: 'price_1S9XOuKAY8PM72pr6833ohwK5' } },
  aesthetician: { group: { annual: 'price_1S9XJqKAY8PM72prO8rmnS87', monthly: 'price_1S9XL5KAY8PM72prptIVQYu3', hour: 'price_1S9XL6KAY8PM72prm9OOnmka' }, oneOnOne: { annual: 'price_1S9XFkKAY8PM72prrAedQV1c', monthly: 'price_1S9XHhKAY8PM72pr0QpAOTTv', hour: 'price_1S9XHhKAY8PM72prxCWUl1Mr' } },
  oilgas: { group: { annual: 'price_1S9XChKAY8PM72prcmctGXfZ', monthly: 'price_1S9XE2KAY8PM72prmDubK1PB', hour: 'price_1S9XE2KAY8PM72prELHKcHJo' }, oneOnOne: { annual: 'price_1S9X58KAY8PM72prsXS4bjtQ', monthly: 'price_1S9X7HKAY8PM72prZLSomS0g', hour: 'price_1S9X7HKAY8PM72pr9I3wOMBe' } },
  hotel: { group: { annual: 'price_1S9Sj9KAY8PM72prfUo7Dmv9', monthly: 'price_1S9SkDKAY8PM72pr6Bbi8GGu', hour: 'price_1S9SkDKAY8PM72prTxN1shIn' }, oneOnOne: { annual: 'price_1S9SfqKAY8PM72prXlQuqHWG', monthly: 'price_1S9Sh3KAY8PM72pru0Bpet5e', hour: 'price_1S9Sh3KAY8PM72prBTsjGBbI' } },
  mining: { group: { annual: 'price_1S9SdCKAY8PM72prjJ5kGjVM', monthly: 'price_1SJyH2KAY8PM72prT5UPX5dS', hour: 'price_1S9SeGKAY8PM72prtMh1Aw7W' }, oneOnOne: { annual: 'price_1S9SaKKAY8PM72prQLQfySvV', monthly: 'price_1S9SbZKAY8PM72pr9Dyj1SgC', hour: 'price_1S9SbaKAY8PM72pr1ouMBrkX' } },
  banking: { group: { annual: 'price_1S9SXgKAY8PM72prEgSwwSKF', monthly: 'price_1SJjOwKAY8PM72prpO2TpuWu', hour: 'price_1S9SZ0KAY8PM72prLjcgO4fU' }, oneOnOne: { annual: 'price_1S9STpKAY8PM72prgBdRUmgz', monthly: 'price_1SJjRvKAY8PM72prm7iQYHHb', hour: 'price_1S9SVBKAY8PM72prvFZWoQW5' } },
  logistics: { group: { annual: 'price_1S9SQMKAY8PM72prflcvyg7V', monthly: 'price_1S9SRcKAY8PM72prJY0wwCiD', hour: 'price_1S9SRcKAY8PM72praeK3Lia5' }, oneOnOne: { annual: 'price_1S9SNGKAY8PM72pr3P8DDlD7', monthly: 'price_1S9SOaKAY8PM72preqD1krGe', hour: 'price_1S9SOaKAY8PM72prJVNmNhPU' } },
  medical: { group: { annual: 'price_1S9SIxKAY8PM72pr8OQyJSB8', monthly: 'price_1S9SKWKAY8PM72prMnfgQ0UR', hour: 'price_1S9SKWKAY8PM72prNHcM9YNv' }, oneOnOne: { annual: 'price_1S9SErKAY8PM72pra3klqu7m', monthly: 'price_1S9SGjKAY8PM72prqoXlByr6', hour: 'price_1S9SGjKAY8PM72prEhpCqFJI' } },
  legal: { group: { annual: 'price_1S9S9pKAY8PM72prJuGB4l2R', monthly: 'price_1S9SCpKAY8PM72prJFyR8dDi', hour: 'price_1S9SCpKAY8PM72prlakUZWks' }, oneOnOne: { annual: 'price_1S9QF8KAY8PM72prnVKLMGDw', monthly: 'price_1S9S2SKAY8PM72prVmOG3TDf', hour: 'price_1S9S2SKAY8PM72prhDEqm3dV' } },
  aviation: { group: { annual: 'price_1S9Eq5KAY8PM72prNo1myYP9', monthly: 'price_1S9EmdKAY8PM72proAWWBWZV', hour: 'price_1S9Eq5KAY8PM72prtGwkQzAM' }, oneOnOne: { annual: 'price_1S9EjBKAY8PM72prpELw2JgV', monthly: 'price_1S9EjBKAY8PM72prRVIzGa3B', hour: 'price_1S9EjBKAY8PM72prxVJ62g1T' } }
};

const AVATAR_MAP = {
  aesthetician: 'aesthetician_avatar.png',
  banking: 'banking_avatar.png',
  cabin: 'cabin_crew_avatar.png',
  'custom-track': 'dream_achievers_avatar.png',
  hotel: 'hotel_avatar.png',
  legal: 'legal_avatar.png',
  logistics: 'logistics_avatar.png',
  medical: 'medical_avatar.png',
  mining: 'mining_avatar.png',
  oilgas: 'oil_gas_avatar.png',
  aviation: 'pilots_avatar.png',
  'young-genius': 'young_geniuses_avatar.png'
};

const LANGUAGE_NAMES = {
  en: 'English', ar: 'العربية', es: 'Español', fr: 'Français', de: 'Deutsch',
  pt: 'Português', ru: 'Русский', zh: '中文', ja: '日本語', ko: '한국어',
  tr: 'Türkçe', he: 'עברית', fa: 'فارسی', hi: 'हिन्दी', it: 'Italiano',
  ku: 'Kurdî', ms: 'Melayu', sw: 'Kiswahili', th: 'ไทย', tl: 'Tagalog',
  uk: 'Українська', ur: 'اردو', vi: 'Tiếng Việt'
};

const HomePage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [showPricing, setShowPricing] = useState(null);
  const [selectedMode, setSelectedMode] = useState('group');
  const [isChatOpen, setIsChatOpen] = useState(false); 
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const refId = searchParams.get('ref');
    if (refId) {
      localStorage.setItem('aulice_ref_id', refId);
    }
  }, [searchParams]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const flagLanguages = [
    'en', 'ar', 'es', 'fr', 'de', 'pt', 'ru', 'zh',
    'ja', 'ko', 'tr', 'he', 'fa', 'hi', 'it', 'ku',
    'ms', 'sw', 'th', 'tl', 'uk', 'ur', 'vi'
  ];

  const handleNavigation = (courseId, actionType) => {
    let route;
    switch (actionType) {
      case 'argot': route = `/argot/${courseId}`; break;
      case 'form': route = `/${courseId}/form`; break;
      case 'quiz': route = `/${courseId}/quiz`; break;
      default: route = `/${courseId}/${actionType}`; break;
    }
    navigate(route);
  };

  const handleEnrollClick = (courseId) => {
    setShowPricing(courseId);
    setSelectedMode('group');
  };

  const handleEnroll = async (courseId, plan) => {
    const user = auth.currentUser;
    if (!user) {
      alert('Please sign in or create an account to enroll.');
      navigate('/login');
      return;
    }

    const priceId = STRIPE_PRICES[courseId]?.[selectedMode]?.[plan];
    if (!priceId) {
      alert(t('pricingError') || 'Pricing not available.');
      return;
    }

    let refId = searchParams.get('ref') || localStorage.getItem('aulice_ref_id');

    try {
      const functions = getFunctions();
      const createCheckout = httpsCallable(functions, 'createCheckoutSession');
      const { data } = await createCheckout({ 
        priceId, 
        courseId, 
        plan,
        refId: refId || null
      });
      
      if (data.sessionUrl) {
        window.location.assign(data.sessionUrl);
      } else {
        throw new Error("Stripe session URL was not returned.");
      }
    } catch (err) {
      console.error('Checkout error:', err);
      alert(`${t('checkoutFailed')}: ${err.message}`);
    }
  };

  const courseIds = [
    'banking', 'logistics', 'mining', 'medical', 'oilgas',
    'aviation', 'aesthetician', 'legal', 'hotel', 'cabin',
    'young-genius', 'custom-track'
  ];

  const courseIcons = {
    banking: '🏦', logistics: '🚢', mining: '⛏️', medical: '⚕️',
    oilgas: '⛽', aviation: '✈️', aesthetician: '✨', legal: '⚖️',
    hotel: '🏨', cabin: '🧑‍✈️', 'young-genius': '🧠', 'custom-track': '🚀'
  };

  const courseTranslations = {
    'young-genius': {
      name: t('courses.young-genius.name', 'Young Genius'),
      description: t('courses.young-genius.description', 'Fun, gamified learning for younger minds.')
    },
    'custom-track': {
      name: t('courses.custom-track.name', 'Dream Achiever Track'),
      description: t('courses.custom-track.description', 'A custom-built plan for your unique goal.')
    }
  };

  return (
    <section className="py-12 bg-gray-50 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        
        {/* --- HERO SECTION --- */}
        <header className="homepage-hero text-center mb-16 relative">
          
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            {t('home_page.title')}
          </h1>
          <p className="text-gray-600 mt-2 text-xl max-w-2xl mx-auto">
            {t('home_page.subtitle')}
          </p>

          {/* --- THE MEDIA DOCK --- */}
          <div className="flex flex-wrap justify-center gap-8 mt-10 z-20 relative">
            
            {/* 1. PLAY AUTARKY */}
            <a href="https://aulice.ca/autarky" className="group flex flex-col items-center hover:scale-110 transition duration-300">
              <div className="w-16 h-16 bg-black rounded-full border-2 border-indigo-500 flex items-center justify-center shadow-lg">
                <img src="/assets/buttons/autarky_button.png" alt="Autarky" className="w-12 h-auto" />
              </div>
              <span className="mt-2 text-indigo-900 font-bold tracking-widest text-xs uppercase">AUTARKY</span>
            </a>

            {/* 2. PLAY VERIDIAN */}
            <a href="https://aulice.ca/veridian" className="group flex flex-col items-center hover:scale-110 transition duration-300">
              <div className="w-16 h-16 bg-black rounded-full border-2 border-cyan-400 flex items-center justify-center shadow-lg">
                <img src="/assets/buttons/veridian_button.png" alt="Veridian" className="w-10 h-auto" />
              </div>
              <span className="mt-2 text-cyan-600 font-bold tracking-widest text-xs uppercase">VERIDIAN</span>
            </a>

            {/* 3. WATCH (YouTube) */}
            <a href="https://www.youtube.com/@AuliceAcademy" target="_blank" rel="noreferrer" className="group flex flex-col items-center hover:scale-110 transition duration-300">
              <div className="w-16 h-16 bg-black rounded-full border-2 border-red-500 flex items-center justify-center shadow-lg">
                <img src="/assets/buttons/video_button.png" alt="Watch" className="w-10 h-auto" />
              </div>
              <span className="mt-2 text-red-600 font-bold tracking-widest text-xs uppercase">WATCH</span>
            </a>

            {/* 4. LISTEN (Ximalaya) */}
            <a href="https://www.ximalaya.com/zhubo/206043573" target="_blank" rel="noreferrer" className="group flex flex-col items-center hover:scale-110 transition duration-300">
              <div className="w-16 h-16 bg-white rounded-full border-2 border-orange-500 flex items-center justify-center shadow-lg">
                <img src="/assets/buttons/ximalaya-logo-png_seeklogo-610502.png" alt="Ting" className="w-10 h-auto" />
              </div>
              <span className="mt-2 text-orange-600 font-bold tracking-widest text-xs uppercase">TING</span>
            </a>

            {/* 5. VK */}
            <a href="https://vk.com/aulice_pro" target="_blank" rel="noreferrer" className="group flex flex-col items-center hover:scale-110 transition duration-300">
              <div className="w-16 h-16 bg-white rounded-full border-2 border-blue-500 flex items-center justify-center shadow-lg overflow-hidden">
                <img src="/assets/buttons/VK_button.jpg" alt="VK" className="w-full h-full object-cover" />
              </div>
              <span className="mt-2 text-blue-600 font-bold tracking-widest text-xs uppercase">VK</span>
            </a>

            {/* 6. WEIBO */}
            <a href="https://weibo.com/aulice" target="_blank" rel="noreferrer" className="group flex flex-col items-center hover:scale-110 transition duration-300">
              <div className="w-16 h-16 bg-white rounded-full border-2 border-red-500 flex items-center justify-center shadow-lg">
                 <img src="/assets/buttons/weibo_button.png" alt="Weibo" className="w-10 h-auto" />
              </div>
              <span className="mt-2 text-red-600 font-bold tracking-widest text-xs uppercase">WEIBO</span>
            </a>

            {/* 7. THE SYNAPSE */}
            <button onClick={() => setIsChatOpen(true)} className="group flex flex-col items-center hover:scale-110 transition duration-300">
              <div className="w-16 h-16 bg-[#1a365d] rounded-full border-2 border-blue-400 flex items-center justify-center shadow-lg">
                <img src="/assets/buttons/synapse.png" alt="Synapse" className="w-10 h-auto" />
              </div>
              <span className="mt-2 text-blue-800 font-bold tracking-widest text-xs uppercase">SYNAPSE</span>
            </button>

          </div>

          {/* --- SMALL EXAM DRUM --- */}
          <div className="mt-8 flex justify-center opacity-90 scale-90">
            <ExamDrum />
          </div>

          {/* Language Flags Section */}
          <div className="mt-8 flex justify-center flex-wrap gap-6">
            {flagLanguages.map((lng) => (
              <div key={lng} className="flex flex-col items-center">
                <button
                  onClick={() => changeLanguage(lng)}
                  className={`w-8 h-8 rounded-full overflow-hidden border-2 transition-transform duration-200 hover:scale-110 shadow-sm ${
                    i18n.language === lng ? 'border-indigo-600 ring-2 ring-indigo-200 scale-110' : 'border-gray-200'
                  }`}
                  style={{
                    backgroundImage: `url('/flags/${lng}.png')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                />
              </div>
            ))}
          </div>

        </header>

        {/* --- COURSES GRID --- */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 gap-y-24">
          {courseIds.map((id) => {
            const isProCourse = !['young-genius', 'custom-track'].includes(id);
            const title = isProCourse ? t(`courses.${id}.name`) : courseTranslations[id].name;
            const description = isProCourse ? t(`courses.${id}.description`) : courseTranslations[id].description;
            
            // ✅ CHECK IF COURSE IS PART OF BOREALIS
            const isBorealisCourse = ['logistics', 'mining', 'oilgas', 'medical', 'aviation', 'legal', 'cabin', 'hotel'].includes(id);

            return (
              <div key={id} className="relative bg-white shadow-lg rounded-xl overflow-visible border-t-4 border-indigo-500 group flex flex-col">
                <div className="absolute -top-16 -right-1 w-24 h-24 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                  <img src={`/avatars/${AVATAR_MAP[id]}`} className="w-full h-full object-contain drop-shadow-lg" onError={(e) => { e.target.style.display = 'none'; }} />
                </div>
                <div className="p-5 flex-grow">
                  <div className="text-3xl mb-2">{courseIcons[id]}</div>
                  <h3 className="text-xl font-extrabold text-gray-800">{title}</h3>
                  
                  {/* ✅ INSERT BOREALIS BADGE HERE IF APPLICABLE */}
                  {isBorealisCourse && <BorealisBadge />}

                  <p className="text-sm text-gray-600 mt-2 overflow-hidden">{description}</p>
                </div>
                <div className="bg-gray-50 p-4 mt-auto">
                  {isProCourse ? (
                    <div className="flex flex-wrap gap-1 justify-center">
                       <button onClick={() => handleNavigation(id, 'demo')} className="bg-yellow-100 text-yellow-800 px-2 py-1 text-xs rounded hover:bg-yellow-200">{t('buttons.demo')}</button>
                       <button onClick={() => handleNavigation(id, 'exam')} className="bg-blue-100 text-blue-800 px-2 py-1 text-xs rounded hover:bg-blue-200">{t('buttons.exam')}</button>
                       <button onClick={() => handleNavigation(id, 'pathway')} className="bg-purple-100 text-purple-800 px-2 py-1 text-xs rounded hover:bg-purple-200">{t('buttons.pathway')}</button>
                       <button onClick={() => handleNavigation(id, 'scenario')} className="bg-green-100 text-green-800 px-2 py-1 text-xs rounded hover:bg-green-200">{t('buttons.scenario')}</button>
                       <button onClick={() => handleNavigation(id, 'unit1')} className="bg-pink-100 text-pink-800 px-2 py-1 text-xs rounded hover:bg-pink-200">{t('buttons.unit1')}</button>
                       <button onClick={() => handleNavigation(id, 'argot')} className="bg-gray-100 text-gray-800 px-2 py-1 text-xs rounded font-medium hover:bg-gray-200">{t('buttons.argot')}</button>
                    </div>
                  ) : (
                    <div className="grid grid-cols-2 gap-2">
                      <button onClick={() => handleNavigation(id, 'form')} className="px-3 py-2 bg-red-600 text-white rounded-md text-xs font-medium hover:bg-red-700">{t('buttons.start_journey')}</button>
                      <button onClick={() => handleNavigation(id, 'quiz')} className="px-3 py-2 bg-yellow-400 text-gray-800 rounded-md text-xs font-medium hover:bg-yellow-500">{t('buttons.play_quiz')}</button>
                    </div>
                  )}
                  {isProCourse && (
                    <div className="mt-3 text-center">
                      <button onClick={() => handleEnrollClick(id)} className="w-full bg-indigo-600 text-white text-sm font-semibold py-2 rounded-lg hover:bg-indigo-700 shadow-sm">{t('buttons.enroll')}</button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Pricing Modal & Messenger */}
      {showPricing && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
             <div className="bg-white p-6 rounded-lg max-w-md w-full mx-4 shadow-2xl">
                <h3 className="text-xl font-bold mb-4">{t('enrollIn')} {t(`courses.${showPricing}.name`)}</h3>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('chooseFormat')}</label>
                  <div className="flex gap-2">
                    <button onClick={() => setSelectedMode('group')} className={`px-3 py-1 rounded flex-1 transition ${selectedMode === 'group' ? 'bg-indigo-600 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}>{t('groupMode')}</button>
                    <button onClick={() => setSelectedMode('oneOnOne')} className={`px-3 py-1 rounded flex-1 transition ${selectedMode === 'oneOnOne' ? 'bg-indigo-600 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}>{t('oneOnOne')}</button>
                  </div>
                </div>
                <div className="space-y-3">
                  <button onClick={() => handleEnroll(showPricing, 'annual')} className="w-full py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-bold shadow">{t('annualAccess')}</button>
                  <button onClick={() => handleEnroll(showPricing, 'monthly')} className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-bold shadow">{t('monthlySubscription')}</button>
                  <button onClick={() => handleEnroll(showPricing, 'hour')} className="w-full py-3 bg-amber-600 text-white rounded-lg hover:bg-amber-700 font-bold shadow">{t('payPerClass')}</button>
                </div>
                <button onClick={() => setShowPricing(null)} className="mt-4 text-gray-600 hover:underline w-full text-center">{t('cancel')}</button>
             </div>
          </div>
      )}
      <InternalMessenger isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </section>
  );
};

export default HomePage;